import { createFileRoute } from "@tanstack/react-router";
import AdminModeratedImageDetailPage from "@/admin/pages/moderated-image-detail";
import { isBlockedFilter, isImageSource, type BlockedFilter } from "@/admin/pages/moderated-images";

/**
 * The `l*` keys are the queue page this image was opened from, for the header's
 * Previous / Next. `lblocked` is always sent, so its presence is what tells the header
 * it has a list to walk; `lpage` is 1-based and moves as Prev/Next crosses a boundary.
 */
export type AdminModeratedImageDetailSearch = {
  lblocked?: BlockedFilter;
  lsource?: string;
  lpage?: number;
};

export const Route = createFileRoute("/admin/moderated-images/$id")({
  component: AdminModeratedImageDetailPage,
  validateSearch: (search: Record<string, unknown>): AdminModeratedImageDetailSearch => ({
    lblocked: isBlockedFilter(search.lblocked) ? search.lblocked : undefined,
    lsource: isImageSource(search.lsource) ? search.lsource : undefined,
    lpage:
      typeof search.lpage === "number" && Number.isInteger(search.lpage) && search.lpage > 1
        ? search.lpage
        : undefined,
  }),
});
